import FiltersDrawerSection from './FiltersDrawerSection'

export default FiltersDrawerSection
